import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Silence noisy dev-only console output in production; keep warn/error for real issues.
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
